import { useSearchForFields } from 'app/hooks';

export default () => {
  const searchForFields = useSearchForFields();

  return async (customSearchParameters = {}) => {
    const updatedCustomSearchParameters = {
      ...customSearchParameters,
      pagesize: 0,
    };

    return searchForFields(updatedCustomSearchParameters, [
      'totalNumberOfResults',
    ]);
  };
};
